import { useDispatch } from 'react-redux'
import cn from 'clsx'

// Components
import { Checkbox } from '@tracklib/kit'

// Hooks
import { useCurrentQuery } from 'modules/browse/hooks'

// Actions
import { actions as browseActions } from 'modules/browse/actions'

import styles from './multitrackfilter.css'

type MultitrackFilterProps = {
  className?: string
}

const MultitrackFilter = ({ className }: MultitrackFilterProps) => {
  const dispatch = useDispatch()
  const currentQuery = useCurrentQuery()

  const handleChange = () => {
    const { multitrack, ...currentQueryWithoutMultitrack } = currentQuery
    return dispatch(
      browseActions.updateSearchWithQuery({ ...currentQueryWithoutMultitrack, ...(multitrack ? {} : { multitrack: 'true' }) }),
    )
  }

  return (
    <Checkbox value={currentQuery.multitrack} type="white" onChange={handleChange} className={cn(styles.checkbox, className)}>
      Songs with multitracks
    </Checkbox>
  )
}

export default MultitrackFilter
